<template>
	<div id="login" :class="isLoggedOn ? 'input-heading' : 'input-heading notLoggedin'">
		<div class="login-status" v-if="isLoggedOn && !isMobile">
			<span>{{ displayName }}</span>
			<span>{{ casinoName ? casinoName : "No casino selected" }}</span>
			<button class="btn" type="button" title="Logout" @click="showLogoutDialog()">Logout</button>
		</div>
		<div class="input-section" v-if="!isLoggedOn">
			<!-- <label for="casinoId" v-if="!serverGettingCasinos && casinoList?.length > 0">Please select a casino: </label> -->
			<label for="casinoId">Please log in</label>
			<div v-if="serverGettingCasinos || serverBusy" id="casino-list-loading">
				<span class="loading-icon"></span>
				{{ getCasinoText || busyText }}
			</div>
			<!-- <DropdownMenu v-if="casinoList.length > 0 && !isMobile" :casinoList="casinoList" :defaultCasinoId="casinoId" />
			<select title="Select Casino" v-if="!serverGettingCasinos && casinoList?.length > 0 && isMobile" v-model="casinoId" id="casinoId">
				<option v-for="casino in casinoList" v-bind:key="casino" :value="casino.id">
					{{ casino.name }}
				</option>
			</select> -->
			<input
				type="tel"
				pattern="[0-9]+"
				name="username"
				@keyup.enter="login()"
				v-model="username"
				placeholder="Phone Number"
				autocomplete="username"
			/>
			<input
				:type="unhidePassword ? 'text' : 'password'"
				name="password"
				@keyup.enter="login()"
				v-model="password"
				placeholder="Password"
				autocomplete="new-password"
			/>
			<span
				class="eye-span"
				@click="unhidePassword = unhidePassword ? false : true"
				:class="unhidePassword ? 'hidden' : ''"
				:title="unhidePassword ? 'Hide password' : 'Unhide password'"
			>
				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="eye" viewBox="0 0 16 16">
					<path
						d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"
					/>
					<path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
				</svg>
			</span>
			<button class="btn" type="button" title="Login" @click="login()">Login</button>
		</div>
		<dialog id="logout-dialog">
			<div>
				<p>
					{{ `Are you sure you want to logout?` }}
				</p>
				<div id="btn-container">
					<button id="confirmButton" class="btn" value="default" @click="logout()">Ok</button>
					<button id="cancelButton" class="btn" value="cancel" formmethod="dialog" @click="closeModal()">Cancel</button>
				</div>
			</div>
		</dialog>
	</div>
</template>

<script>
// @ is an alias to /src
import router from "@/router";
import sharedScripts from "@/dependencies/sharedScripts";
import DropdownMenu from "@/components/DropdownMenu";

export default {
	name: "Login",
	components: {
		DropdownMenu,
	},
	props: {
		adminState: Object,
		casinoList: Array,
		sessionRefreshCheck: Number,
		isMobile: Boolean,
		serverGettingCasinos: Boolean,
		getCasinoText: String,
		systemSettings: Object,
	},
	watch: {
		isLoggedOn() {
			if (!this?.isLoggedOn) router.push("/");
		},
		adminState: {
			handler(val, oldVal) {
				this.updateCasinoInfo();
			},
			deep: true,
		},
		sessionRefreshCheck: {
			handler(val, oldVal) {
				this.updateCasinoInfo();
			},
		},
		casinoList: {
			handler() {
				this.casinoId = this.casinoList.length > 0 ? 1 : null;
			},
			deep: true,
		},
	},
	data() {
		return {
			status: Object.assign({}, this.globalStatus),
			isLoggedOn: false,
			serverBusy: false,
			busyText: "",
			accessToken: "",
			accessTokenExpiration: "",
			refreshToken: "",
			userPermissions: {
				userId: "",
				globalPermissions: "",
				sitePermissions: {},
			},
			sitePermissions: {},
			isCashier: false,
			isReporter: false,
			isSiteAdmin: false,
			isSysadmin: false,
			isHelpDesk: false,
			isManager: false,
			username: "",
			displayName: "",
			password: "",
			userId: "",
			casinoId: null,
			casinoName: "",
			casinoDescription: "",
			unhidePassword: false,
			inputDialog: null,
		};
	},
	created() {
		this.eventBus.on("forceLogout", () => {
			this.logout(true);
			// Need to make sure refreshTokenAwait is false on logout
			this.refreshTokenAwait = false;
		});
		this.eventBus.on("regularLogout", () => {
			this.logout();
			// Need to make sure refreshTokenAwait is false on logout
			this.refreshTokenAwait = false;
		});
		this.eventBus.on("casinoSelected", (payload) => {
			this.casinoId = payload.id;
		});
		this.eventBus.on("regularLogout", () => {
			this.showLogoutDialog();
		});
	},
	async mounted() {
		this.inputDialog = document.getElementById("logout-dialog");
		this.casinoId = this.casinoList.length > 0 ? 1 : null;
		this.isLoggedOn = this.adminState?.isLoggedOn || false;
		this.userId = this.adminState?.userId || "";
		this.username = this.adminState?.username || "";
		this.displayName = this.adminState?.displayName || "";
		this.userPermissions = this.adminState?.userPermissions || {};
		this.sitePermissions = this.adminState?.userPermissions?.sitePermissions || {};
		if (Object.keys(this.sitePermissions).length > 0) {
			this.isSiteAdmin = this.sitePermissions[this.adminState.casinoId]?.includes("SiteAdmin") ? true : false;
			this.isCashier = this.sitePermissions[this.adminState.casinoId]?.includes("Cashier") ? true : false;
			this.isReporter = this.sitePermissions[this.adminState.casinoId]?.includes("Reporter") ? true : false;
		}
		this.eventBus.emit("checkAndRefreshSession");
	},
	methods: {
		showLogoutDialog() {
			this.inputDialog.showModal();
		},
		closeModal() {
			this.inputDialog.close();
		},
		updateCasinoInfo() {
			if (this.adminState?.isLoggedOn) {
				this.isLoggedOn = this.adminState.isLoggedOn;
				this.casinoId = this.adminState.casinoId;
				this.casinoName = this.adminState.casinoName;
				this.sitePermissions = this.adminState.userPermissions?.sitePermissions || {};
			} else {
				this.isLoggedOn = false;
				this.casinoId = this.casinoList.length > 0 ? 1 : null;
				this.casinoName = "";
				this.sitePermissions = {};
			}
		},
		async login() {
			let _state = this.adminState;
			this.status.ok = true;

			if (this.username.match(/[^0-9]/)) {
				this.status.message = "Phone number must be numbers only.";
				this.status.ok = false;
				this.eventBus.emit("updateStatus", this.status);
			}

			if (!this.username) {
				this.status.message = "Please provide a valid phone number.";
				this.status.ok = false;
				this.eventBus.emit("updateStatus", this.status);
			}

			if (!this.password) {
				this.status.message = "Please provide a password.";
				this.status.ok = false;
				this.eventBus.emit("updateStatus", this.status);
			}

			if (this.status.ok === false) return this.status;

			this.serverBusy = true;
			this.busyText = "Checking credentials";

			try {
				let body = {
					phoneNumber: this.username.replace(/\D/g, ""),
					password: this.password,
				};

				let requestUrl = new URL("/api/v1/authentication/login", this.rabbitsfootHostUrl);
				let headerObj = new Headers();
				headerObj.append("Content-Type", "application/json; charset=utf-8");
				let request = new Request(requestUrl.toString(), {
					method: "POST",
					body: JSON.stringify(body),
					headers: headerObj,
				});
				const response = await fetch(request);

				let fetchStatus = sharedScripts.checkFetchErrors(response);

				if (fetchStatus && !fetchStatus.ok) {
					fetchStatus.message = fetchStatus.code === 404 ? "Phone number or password is incorrect" : fetchStatus.message;
					fetchStatus.message = fetchStatus.code === 401 ? "Login is incorrect": fetchStatus.message;
					this.eventBus.emit("updateStatus", fetchStatus);
					this.serverBusy = false;
					this.busyText = "";
					return;
				}

				let dataJson = await response.json();

				_state.accessToken = dataJson.accessToken;
				_state.accessTokenExpiration = dataJson.accessTokenExpiration;
				_state.refreshToken = dataJson.refreshToken;
				_state.userId = dataJson.userId;
				_state.username = this.username;
				_state.displayName = this.displayName = dataJson.displayName;
				_state.isLoggedOn = this.isLoggedOn = true;
				_state.userPermissions = this.userPermissions = dataJson.permissions;
				_state.permissionsSuspended = this.permissionsSuspended = dataJson.permissions.arePermissionsSuspended;
				_state.sitePermissions = this.sitePermissions = this.userPermissions.sitePermissions;
				_state.loggedOnTimeCode = new Date().getTime();
				_state.systemSettings = this.systemSettings;
				_state.phoneCountryCode = dataJson.phoneCountryCode;

				this.activeSession = _state;

				let thisCasino = this.casinoList.filter((casino) => casino.id === this.casinoId)[0];
				_state.casinoName = this.casinoName = thisCasino?.id ? thisCasino.name : "";
				_state.currencyInfo = thisCasino?.currencyInfo;
				_state.casinoDescription = this.casinoDescription = thisCasino?.id ? thisCasino.description : "";
				_state.casinoId = thisCasino?.id ? thisCasino.id : null;
				this.isSysadmin = this.userPermissions?.globalPermissions?.includes("Sysadmin") ? true : false;
				this.isHelpDesk = this.userPermissions?.globalPermissions?.includes("HelpDesk") ? true : false;
				this.isManager = this.sitePermissions?.[_state.casinoId]?.includes("Manager") ? true : false;
				this.isSiteAdmin = this.sitePermissions?.[_state.casinoId]?.includes("SiteAdmin") ? true : false;
				this.isCashier = this.sitePermissions?.[_state.casinoId]?.includes("Cashier") ? true : false;
				this.isReporter = this.sitePermissions?.[_state.casinoId]?.includes("Reporter") ? true : false;
				_state.isSysadmin = this.isSysadmin;
				_state.isSiteAdmin = this.isSiteAdmin;
				_state.isHelpDesk = this.isHelpDesk;
				_state.isManager = this.isManager;
				_state.isCashier = this.isCashier;
				_state.isReporter = this.isReporter;
				_state.loggedOnTimeCode = new Date().getTime();
				_state.isSiteAdminAtAnyCasino = this.findSiteAdminAtCasino(this.sitePermissions, false);
				_state.systemSettings = this.systemSettings;
				_state.phoneCountryCode = dataJson.phoneCountryCode;
				_state.siteAdminCasinoId = this.findSiteAdminAtCasino(this.sitePermissions,true);

				this.activeSession = _state;
				if (this?.adminState?.isSysadmin) this.eventBus.emit("updateCasinosIncludingDeleted");

				this.password = "";
				this.unhidePassword = false;

				this.eventBus.emit("updateStatus", fetchStatus);
				this.eventBus.emit("checkAndRefreshSession");
				this.eventBus.emit("updateAdminState", _state);
				this.eventBus.emit("resetCurrencyToolConstructor");
				this.serverBusy = false;
				this.busyText = "";
				router.push("/");
			} catch (e) {
				console.error(e);
			}
		},
		logout(forced = false) {
			// if (!forced) {
			//	let confirmLogout = confirm(`Are you sure you want to logout, ${this.displayName}`);
			//	if (!confirmLogout) return false;
			// }
			this.isLoggedOn = this.isCashier = this.isReporter = this.isSiteAdmin = false;
			this.displayName = this.username = "";
			this.userPermissions = this.activeSession = {};
			this.adminState.casinoId = null;
			this.unhidePassword = false;
			this.eventBus.emit("updateSelectedUser", {});
			this.eventBus.emit("toggleNavBar", true);
			this.eventBus.emit("resetCasinosIncludingDeleted");
			this.eventBus.emit("updateAdminState", this.activeSession);
			this.closeModal();
			router.push("/");
		},
		findSiteAdminAtCasino(permissionsList, getCasinoId){
			for (const key in permissionsList) {
				if (permissionsList[key].includes("SiteAdmin")) {
					let casino = this.casinoList.filter((casino) => casino.id == key)[0];
					if(getCasinoId) return casino.id;
					return true;
				}
			}
		}
	},
};
</script>

<!-- scoped attribute to limit CSS to this component only -->
<style scoped>
#login {
	position: fixed;
	z-index: 100;
}

#login.notLoggedin {
	position: fixed;
	width: 100%;
	height: 100%;
	display: grid;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 1;
	margin: auto;
	align-content: center;
	background-color: rgb(0 0 0 / 60%);
	backdrop-filter: blur(5px);
}

#login .input-section {
	display: flex;
	flex-direction: column;
	background: rgb(71 68 196 / 40%);
	padding: 30px;
	border-radius: 12px;
	box-shadow: inset -1px -1px 15px 1px rgb(13 28 37 / 50%);
	width: auto;
	margin: auto;
	position: relative;
}

.login-status {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	position: fixed;
	top: 0;
	right: 0;
	padding: 5px 10px;
	font-size: 0.625em;
	background-color: #32373f;
	border-radius: 0 0 0 0.4em;
	border: 1px #5b88c0 solid;
}

.login-status button {
	user-select: none;
	margin: 8px auto;
	padding: 5px;
}

label[for="casinoId"] {
	text-align: center;
	text-transform: uppercase;
	text-shadow: -1px -1px 0px #000, 1px -1px 0px #000, -1px 1px 0px #000, 1px 1px 0px #000;
}

#casino-list-loading {
	display: block;
	padding: 0;
	margin: auto;
}

button {
	margin: 5px auto 0;
}

/* iOS specific CSS */
@supports (-webkit-touch-callout: none) {
	.eye-span {
		top: 8px;
	}
}

.eye-span::after {
	content: "I";
	position: absolute;
	right: 8px;
	top: -7px;
	transform: rotate(45deg);
	font-size: 2em;
	font-weight: bold;
}

.eye-span {
	position: absolute;
	right: 45px;
	top: 98px;
	color: #000;
	cursor: pointer;
}

.eye-span .eye {
	width: 1.5em;
	height: auto;
}

.eye-span.hidden {
	color: #008000;
}

.eye-span.hidden::after {
	content: none;
}
</style>
